namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DialogTestAibConnectors extends GContentBase<DetailBase> {
        private view: Gordic.Data.View;
        private basePanel: JQuery<HTMLElement>;
        private implementatorMail: string;
        private subject: string;
        private isDebug: boolean;

        onContentReady() {
            this.createActions();
            this.createMenuBar();
            this.loadDiagnostika();
        }

        private loadDiagnostika() {
            if (this.basePanel != undefined)
                this.basePanel.empty();
            this.beginOperation();
            this.isl.AdmDiagnostikaAib.getDiagnostika().get().done((result) => {
                this.view = new Gordic.Data.View(result);
                this.basePanel = $("<div>").appendTo(this.element).gbasepanel({
                    data: this.view,
                    itemClassTemplate: "diagnostika-item",
                    columnCount: 3,
                    fixedWidth: false,
                    toolbar: {
                        top: () => {
                            return [
                                {
                                    action: this.actions.actSend,
                                    captionVisible: "never",
                                }
                            ]
                        }
                    },
                    itemTemplate: (row) => {
                        var html = ""
                        html += "<h2>{0}</h2>".format(row.name?.toString())
                        html += "<table>";
                        if (row.errorGuid != null && row.errorGuid) {
                            html += "<tr><td><b>jres:33000852</b></td></tr>".format("<span style='color: #C63C3C'>{0}</span>".format(row.errorGuid)); //RC 33000852 : AIB komunikuje, ale vrací následující identifikátor chyby: <br />{0}<br /><br />Pod tímto identifikátorem naleznete v logu na serveru AIB podrobnější informace a následně kontaktujte autora konektoru AIB.
                        } else if (row.error != null && row.error != undefined) {
                            html += `<tr><td><b>jres:33000850:</b> <span style='color: #C63C3C'><b>${row.error}</b></span></td></tr>` //RC 33000850 : Chyba
                        } else {
                            var isErrorOutput: boolean = false;
                            var htmlItems = "";
                            row.configItems?.forEach((item) => {
                                var value: string | null | undefined = "";
                                if (item.value.toLowerCase() == "true" || item.value.toLowerCase() == "false") {
                                    var icon = Gordic.Utils.IconBuilder.default.createIcon(item.value.trim().toLowerCase() == "true" ? "fa-check-circle g-state-text g-state-success" : "fa-times-circle  g-state-text g-state-error")
                                    if (item.value.trim().toLowerCase() == "false") 
                                        isErrorOutput = true;
                                    if (typeof icon == "string")
                                        value = icon;
                                } else {
                                    value = item.value?.toString()
                                }
                                htmlItems += "<tr><td><b>{0}:</b> {1}</td></tr>".format(item.key?.toString(), value?.toString())
                            })
                            if (isErrorOutput) {
                                html += "<tr><td style='background-color: #ed1e7933; padding: 0.5rem'><b>jres:33000851</b></td></tr>" //RC 33000851 : Modul se s AIB spojil, ale diagnostika se nezdařila, kontaktujte prosím autora submodulu.
                                html += "<tr><td></td></tr>";
                            }
                            html += htmlItems;
                        }
                        html += "</table>";
                        return html;
                    }
                })
            }).always(() => { this.endOperation() })
        }

        private createActions() {
            this.actions.addRange({
                actReload: {
                    caption: "jres:33000732", //RC 33000732 : Občerstvit
                    icon: "gi-refresh",
                    run: (ev, ctx) => {
                        this.loadDiagnostika();
                    }
                },
                actSend: {
                    caption: "jres:33000733", //RC 33000733 : Odeslat emailem
                    icon: "gi-email",
                    run: (ev, ctx) => {
                        this.dialogEmail(false);
                    }
                },
                actSendAll: {
                    caption: "jres:33000733", //RC 33000733 : Odeslat emailem
                    icon: "gi-email",
                    run: (ev, ctx) => {
                        this.dialogEmail(true);
                    }
                },
                actSendMailOk: {
                    caption: "jres:33000243",
                    run: (ev, ctx) => {
                        this.actions.actSendAll?.setPending(this.sendMailOk(ev))
                    }
                },
                actSendMailCancel: {
                    caption: "jres:32131042",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                },
                actAibConnectorInfo: {
                    caption: "TEST connector",
                    visible: this.isDebug,
                    run: (ev, ctx) => {
                        this.testAibConnector()
                    }
                },
                actLoadLogy: {
                    caption: "jres:33001059", //RC 33001059 : Načíst logy AIB
                    icon: "gi-history",
                    run: (ev, ctx) => {
                        this.loadLogyDialog()
                    }
                }
            })
        }

        private createMenuBar() {
            this.menuBar(this.actions.createBar(["actReload*", "actSendAll*", "actLoadLogy*", "actAibConnectorInfo*"]))
        }

        private dialogEmail(allConectors: boolean) {
            var connector: any[] = [];
            if (allConectors == false) {
                connector = this.basePanel.gbasepanel("getSelection");
            }

            var frm = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1, L-2-10-0, M-3-9-0, S-12-12-0",
            }).addRow("jres:33000735").addField("gstringbox", { //RC 33000735 : E-mail
                name: "email",
                validators: [
                    new Gordic.Validators.Required({
                        stopping: true
                    }),
                    new Gordic.Validators.RegExp({
                        stopping: true,
                        pattern: new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/)
                    })],
                flag: "required"
            }) 

            var form = new Gordic.Forms.Form({
                layoutDescriptor: "L1M1S1",
                customClass: "email-dialog",
                name: "email-dialog"
            }).addRow("jres:33000734").addField("gformbox", { //RC 33000734 : Komu
                name: "to",
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                itemTemplate: "{email}",
                itemWidth: "",
                form: frm,
                initialValue: { email: this.implementatorMail },
                multi: true,
                model: "model.to<=value.email",
                dialogOptions: {
                    height: 200,
                    width: 400
                }
            }).addRow("jres:33000736").addField("gformbox", { //RC 33000736 : Kopie
                name: "copy",
                itemTemplate: "{email}",
                form: frm,
                multi: true,
                itemWidth: "",
                model: "model.copy<=value.email",
                dialogOptions: {
                    height: 100,
                    width: 150
                }
            }).addRow("jres:33000738").addField("gstringbox", { //RC 33000738 : Předmět
                name: "subject",
                validators: [new Gordic.Validators.Required({ stopping: true })],
                flag: "required",
                initialValue: this.subject
            }).addRow("jres:33000740").addField("gselectbox", { //RC 33000740 : Konektrory k odeslání
                name: "konectors",
                dropdown: true,
                multi: true,
                itemTemplate: "{name}",
                disabled: allConectors == false,
                data: this.getDostupneKonektory(),
                initialValue: (allConectors == true) ? this.getDostupneKonektory() : connector,
                model: "model.konectors=value.name",
                itemWidth: ""
            }).addRow("jres:33000737").addField("gstringbox", { //RC 33000737 : Zpráva
                name: "message",
                rows: 5,
            })

            this.dialogs.simpleForm("jres:33000739", form, null, { //RC 33000739 : Odeslat email
                width: 800,
                height: 700,
                commandBar: [
                    {
                        action: this.actions.actSendMailOk,
                        primary: true
                    },
                    {
                        action: this.actions.actSendMailCancel
                    },
                ]
            }) 
        }

        private getDostupneKonektory(): any[] {
            var data = this.view.getDataRows(false, "data");
            var result: { name: string }[] = data.map((item) => ({ name: item.name.toString() }))
            return result; 
        }

        private sendMailOk(ev): JQueryPromise<boolean> {
            var cnt = $.content(ev.target);
            var formData: Gordic.AdmIsl.Interface.GDiagnostikaAibEmailDto = {};
            cnt.findForms("email-dialog").findFields().gfield("model", "collect", formData);
            return this.isl.AdmDiagnostikaAib.sendEmail({ emailDto: formData }).get().done(() => { cnt.close() });
        }

        private testAibConnector() {
            this.isl.AdmDiagnostikaAib.getDiagnostikaTest().get().done((output) => {
                Gordic.Gin.WebClient.CreateAibConnectorDialog(output);
            })
        }

        private loadLogyDialog() {
            this.dialogs.showModalWindow(Gordic.Adm.WebControls.DialogLogsAib, {}, "jres:33001060", 1000, 1000) //RC 33001060 : Logy z AIB
        }
    }
}